import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React from 'react';
import cx from '../../styles';
import { Icon } from '../Common/Icon';
import { ArticleCardPlaceholder } from '../Common/ContentPlaceholder';
import { SuggestedArticleCard } from '../SuggestedArticleCard';

const  Template404 = ({t, suggestedArticles, isLoading}) => {
    return (
        <div className={cx("page-not-found")}>
            <div className={cx("pageNotFound_body")}>
                <div className={cx('left')}>
                    <div className={cx('oops-wrapper')}>
                        <div className={cx("oops")}>
                            <img src={generateAssetCdnUrl("tap-assets/page404", "Oops_.png")} alt="oops" title="oops text" loading="lazy"/>
                        </div>
                        <p className={cx("pageNot_desc")}>
                            The page you're looking for has either been moved or deleted.
                        </p>
                    </div>
                    <div className={cx("download-wrapper")}>
                        <p className={cx('pageNot_desc')}>
                            <span>Download theAsianparent app and join a community of 30 million parents!</span>
                        </p>
                        <div className={cx('app-download-wrap')}>
                            <div className={cx('qrCodeImg')}>
                                <img alt="QR-Code" src={generateAssetCdnUrl("tap-assets", "TAP-QR.png")} loading="lazy"/>
                            </div>
                            <div className={cx('playAppStore')}>
                                <a href="https://play.google.com/store/apps/details?id=com.tickledmedia.ParentTown" target="_blank" rel="noopener noreferrer" aria-label="Google play-store link">
                                    <Icon name='play-store' />
                                </a>
                                <a href="https://itunes.apple.com/app/apple-store/id1042523855?pt=117859879&ct=404-page&mt=8" target="_blank" rel="noopener noreferrer" aria-label="Apple-store link">
                                    <Icon name='app-store' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cx('top-stories')}>
            {
                // <div className={cx('pageNotFound_search')}>
                //     <div className={cx('search-box')}>
                //         <input type="text" placeholder="You may search what you are looking for..." />
                //         <button type="button" className={cx('btn-icon')}><Icon name='search-regular-gray-md' /></button>
                //     </div>
                // </div>
            }
                <h2>
                    <span>You can also have a look at our Top Stories:</span>
                </h2>

                <div className={cx("mixed-feed-tap")}>
                    {
                        suggestedArticles && suggestedArticles.slice(0, 6).map((d, i) => {
                            return <SuggestedArticleCard key={i} data={d} t={t} />
                        })
                    } 
                    {
                        isLoading &&
                        <ArticleCardPlaceholder />
                    }                   
                </div>
            </div>
        </div>
    );
};



export default Template404;